import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type {
  IMPORT_STATE,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type TiktokShopResponse = {
  name: string;
  workspace_id: string;
  state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  shop_name: string;
};

const TiktokShopRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, setRedirect] = useCrossWindowState<TiktokShopResponse | null>(
    'tiktokshop-redirect',
    null,
  );

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const asyncUpdateHandler = async () => {
        const data = await services.tiktokshop.createTiktokShopInfo(
          code,
          state,
        );

        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, searchParams, navigate]);

  return <LoadingLayout>Connecting TikTok Shop...</LoadingLayout>;
};

export default TiktokShopRedirect;
